import { motion } from 'framer-motion';
import styled from 'styled-components';

import { shades } from '@pkg/components/DesignSystem/tokens/shades';
import { styledTypography } from '@pkg/primitives';

export const LoaderHolder = styled.div`
    width: 160px;
`;
export const LoadingStepWrapper = styled.div`
    height: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
`;
export const StepWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    gap: 40px;
`;

export const YatTileWrapper = styled.div`
    font-size: 40px;
`;

export const StepContentWrapper = styled(motion.div)`
    flex-direction: column;
    align-items: center;
    display: flex;
    gap: 20px;
    width: 100%;
`;

export const MetamaskStatusIndicator = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    justify-content: center;
    backdrop-filter: blur(29px);
    background: ${shades.primary.light['10']};
    padding: 10px 25px;
    border-radius: 40px;
    svg {
        width: 24px;
        height: 24px;
    }
`;
export const MetamaskStatusText = styled.p`
    ${styledTypography.allianceBase};
    font-weight: 600;
    font-size: 14px;
    color: #fff;
`;
export const MetamaskStatusDot = styled.div`
    background: #62fa71;
    border-radius: 50%;
    width: 8px;
    height: 8px;
`;

export const NameYatInputWrapper = styled.div`
    width: 100%;
    padding: 0 20px;
    margin-top: 40px;
    &:first-child {
        flex: 0 0 auto;
        padding: 0 0 0 15px;
    }

    &:last-child {
        flex: 1 1 auto;
        min-width: 400px;
    }
`;

export const YatPrefix = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 15px;
    p {
        margin-left: 5px;
    }
`;
export const YatPrefixSprite = styled.div`
    span {
        letter-spacing: -2px;
        font-size: 18px;
    }
`;

export const TermsCheckbox = styled.div`
    align-items: flex-start;
    flex-direction: row;
    gap: 8px;
    cursor: pointer;
    display: flex;
    padding: 0 20px 10px;
`;

export const TermsText = styled.p`
    ${styledTypography.allianceBase};
    font-size: 15px;
    color: #fff;
`;

export const EmojiImage = styled.img`
    width: 200px;
`;
